import { render } from "./CorridorViewer.vue?vue&type=template&id=223d02fd"
import script from "./CorridorViewer.vue?vue&type=script&lang=js"
export * from "./CorridorViewer.vue?vue&type=script&lang=js"

import "./CorridorViewer.vue?vue&type=style&index=0&id=223d02fd&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__